import axios from 'axios';

const resetPassword = async (email: string) => {
  await axios.post(`/reset_password`, {
    email,
  });
};

export default resetPassword;
